angular.module("accordionUpdateDelegato.components", []).component("accordionUpdateDelegato", {
    templateUrl: "ng/components/delegationRequest/accordionUpdateDelegato/accordionUpdateDelegato.view.html",
    bindings: {
        model: "=",
        userDaCensire: "=",
        saveDelegato: "&",
        goBackModal: "&",
        validateDocumentDel: "&"
    },
    controllerAs: "accordionUpdateDelegatoCtrl",
    controller: function AccordionUpdateDelegato(
        $configService,
        $rootScope,
        $timeout,
        Documento,
        $modalService,
        $scope,
        validationService,
        Pf,
        $portalService,
        $userService,
        $istatService
    ) {
        var self = this;

        var getStati = function () {
            $istatService.getNazioni()
                .then(function (response) {
                    console.log(response);
                    self.listaNomiStatiNascita = response.domainList;
                    self.listaNomiStatiNascita = self.listaNomiStatiNascita.filter(
                        function (elem) {
                            return elem.name != "ITALIA";
                        }
                    );
                });
        }

        self.$onInit = (function () {
            self.testDati = {
                value: true,
                error: ""
            }
            self.dealerUser = {};
            self.enteRilascioModel = "";
            self.showLoader = false;
            self.link = "";
            self.mapComuni = $rootScope.comuniMap;
            self.listaProvince = [];
            self.listaProvinceRilascio = [];
            self.listaNomeComuniRilascio = [];
            self.listaNomeComuniNascita = [];
            self.listaNomiStatiNascita = [];
            self.listaNomeComuniResidenza = [];
            self.listaCap = [];
            self.yesterday = moment().add(-1, "days").format("DD/MM/YYYY");
            self.today = moment().format("DD/MM/YYYY");
            self.tomorrow = moment()
                .add(1, "days")
                .format("DD/MM/YYYY");
            self.userDaCensire = self.userDaCensire | {};
            self.documentUpload = [];
            self.enabledModifyDocumentDate = false;
            self.currentSlide = 0;
            self.dropdown = {
                ruolo: [],
                stati: [],
                comune: [],
                statiEsteri: [],
                entiRilascio: [],
                tipiDocumento: [],
                tipoGarante: []
            };
            self.validationObj = {
                documentDate: {
                    disabledDays: [0],
                    disabledDates: [
                        "01-01",
                        "06-01",
                        "25-04",
                        "01-05",
                        "02-06",
                        "15-08",
                        "01-11",
                        "08-12",
                        "25-12",
                        "26-12"
                    ]
                },
                regex: {
                    documentNumber: /.+/
                }
            };

            getStati();

            self.listaProvince = self.mapComuni
                .map(function (comune) {
                    return comune.sigla;
                })
                .filter(function (siglaComune) {
                    return siglaComune != "";
                })
                .sort()
                .reduce(function (result, nextItem) {
                    return result.includes(nextItem) ? result : result.concat(nextItem);
                }, []);
            self.listaProvince.push("EE");
            self.listaProvinceRilascio = self.listaProvince
                .filter(function (elem) {
                    return elem != "EE"
                });

            self.creaComuniRilascio = function (provincia) {
                self.listaNomeComuniRilascio = self.mapComuni
                    .filter(function (comune) {
                        return comune.sigla == provincia;
                    });

                self.userDaCensire.documento.luogoEsteso = "";
            };

            self.creaComuniNascita = function (provincia) {
                self.listaNomeComuniNascita = self.mapComuni
                    .filter(function (comune) {
                        return comune.sigla == provincia;
                    });
                self.userDaCensire.datiNascita.luogoEsteso = "";
                self.verifyDate();
            };

            self.creaComuniResidenza = function (provincia) {
                if (provincia == "EE") {
                    self.isForeign = true;
                    return;
                } else {
                    self.isForeign = false;
                }
                self.listaNomeComuniResidenza = self.mapComuni
                    .filter(function (comune) {
                        return comune.sigla == provincia;
                    });
            };

            self.creaCap = function (comune, chiamataDalRest) {

                if (!chiamataDalRest) {
                    self.userDaCensire.residenza.cap = "";
                }

                if (comune.cap && comune.cap.length > 0) {
                    self.listaCap = comune.cap;

                } else {
                    if (self.listaNomeComuniResidenza.length > 0 && comune.nome) {
                        var tempComune = self.listaNomeComuniResidenza
                            .find(function (element) {
                                return element.nome.toUpperCase() == comune.nome.toUpperCase();
                            });

                        self.listaCap = tempComune && tempComune.cap;
                    }
                }
            };

            $timeout(function () {
                self.userDaCensire = Pf.build(self.userDaCensire);
                self.enteRilascioModel = self.userDaCensire.documento.enteRilascio;

                self.listaNomeRilascio = Documento.getEntiRilascio(
                    self.userDaCensire.documento.tipo
                );
                if (self.userDaCensire.residenza.provincia == "EE") {
                    self.isForeign = true;
                    return;
                } else {
                    self.isForeign = false;
                }
                if (self.userDaCensire.residenza.luogoEsteso.nome == "") {
                    self.userDaCensire.residenza.luogoEsteso = "";
                }
                if (self.userDaCensire.datiNascita.luogoEsteso.nome == "") {
                    self.userDaCensire.datiNascita.luogoEsteso = "";
                }
                if (self.userDaCensire.documento.luogoEsteso.nome == "") {
                    self.userDaCensire.documento.luogoEsteso = "";
                }
                if (self.userDaCensire.residenza.provincia) {
                    self.userDaCensire.residenza.luogoEsteso = {
                        nome: self.userDaCensire.residenza.comune
                    }
                    self.creaComuniResidenza(self.userDaCensire.residenza.provincia, true);
                }
                if (self.userDaCensire.datiNascita.luogoEsteso.nome == "" && self.userDaCensire.datiNascita.provincia) {
                    self.creaComuniNascita(self.userDaCensire.datiNascita.provincia);
                }
                if (self.userDaCensire.documento.luogoEsteso.nome == "" && self.userDaCensire.documento.provincia) {
                    self.creaComuniRilascio(self.userDaCensire.documento.provincia);
                }

                if (self.userDaCensire.residenza.luogoEsteso.nome) {
                    self.creaCap(self.userDaCensire.residenza.luogoEsteso, true);
                }

                if (self.userDaCensire.datiNascita.luogoEsteso.nome == null && self.userDaCensire.datiNascita.comune) {
                    self.userDaCensire.datiNascita.luogoEsteso.nome = self.userDaCensire.datiNascita.comune;
                }

                validateDelModal();
                dealerUser();

            }, 500);

            self.linkPep = $configService.getAppConfig().url +
                '/uni/download/service-infos/' +
                encodeURIComponent('GLOSSARIO') + '/?token=' +
                $configService.getAppConfig().token;

        })(
            (self.loadingStatus = {
                uploading: false,
                loadingDataFromCerved: false,
                savedDataFromCerved: false,
                loading: false,
                loadingAddressesList: false,
                loadingPfList: false,
                insertingContract: false
            })
        );

        self.enteRilascioSelezionato = function (ente) {
            if (self.userDaCensire.documento.tipo === "PAT") {
                if (ente === "MINISTERO") {
                    self.regExpDocumento = "UCO";
                } else if (ente === "DIPARTIM. TRASPORTI TERRESTI") {
                    self.regExpDocumento = "PAM";
                } else if (ente === "PREFETTURA") {
                    self.regExpDocumento = "PAT";
                }
            }
            console.log(ente);
            self.userDaCensire.documento.enteRilascio = {
                name: ente
            };
        };

        self.listaEntiRilascio = function (preserveData) {
            if (preserveData) {
                return;
            }

            self.enabledModifyDocumentDate = true;
            self.documentUpload = self.documentUpload.filter(function (element) {
                return element.type != "imgDocument";
            });
            self.disabledUploadDocument();
        };

        self.savePfData = function (pf) {
            validateDelModal();
            self.saveDelegato({
                value: pf
            })
        };

        self.undoDocumentChanges = function (pf) {
            if (self.isIntegration === true || self.validateForm()) {
                pf.isOk = true;
                $modalService.closeModal("censusDelegatoModal");
                $("#footerInstant").css("z-index", "2");
                $('.financial-leasing__footer').css("z-index", "2");
                jQuery('.mCSB_scrollTools').css("z-index", "2");
            } else {
                pf.isOk = false;
                $modalService.closeModal("censusDelegatoModal");
                $("#footerInstant").css("z-index", "2");
                $('.financial-leasing__footer').css("z-index", "2");
                jQuery('.mCSB_scrollTools').css("z-index", "2");
            }
            self.goBackModal && self.goBackModal();
            validateDelModal();
        };

        self.getEndDate = function (dataRilascio) {
            if (dataRilascio) {
                var tipoDocumento = self.userDaCensire.documento.tipo;
                var dataNascita = self.userDaCensire.datiNascita.data;
                var dataRilascio = moment(dataRilascio, "DD/MM/YYYY");
                var startYear = moment(dataRilascio).format("YYYY");
                var startDay = moment(dataRilascio).format("DD");
                var startMonth = moment(dataRilascio).format("MM");

                var endDate = moment(dataRilascio)
                    .add(10, "years")
                    .format("DD/MM/YYYY");

                if (
                    tipoDocumento === propMap["DOC_TYPE_CAI"] ||
                    tipoDocumento === propMap["DOC_TYPE_NCE"] ||
                    tipoDocumento === propMap["DOC_TYPE_CIE"] ||
                    tipoDocumento === propMap["DOC_TYPE_CAE"] ||
                    tipoDocumento === propMap["DOC_TYPE_PAT"] ||
                    tipoDocumento === propMap['DOC_TYPE_PAM'] ||
                    tipoDocumento === propMap['DOC_TYPE_UCO'] ||
                    self.isM17Map
                ) {
                    var dataNascita = moment(dataNascita, "DD/MM/YYYY");
                    var birthYear = moment(dataNascita).format("YYYY");
                    var birthDay = moment(dataNascita).format("DD");
                    var birthMonth = moment(dataNascita).format("MM");

                    if (birthMonth == '02' && birthDay == '29') {
                        birthMonth = '03';
                        birthDay = '01';
                    }

                    var futureBirthDay = moment(
                        birthDay + "/" + birthMonth + "/" + startYear,
                        "DD/MM/YYYY"
                    )
                        .add(10, "years")
                        .format("DD/MM/YYYY");
                    //console.log("Compleanno Futuro: " + futureBirthDay);

                    var daysDiff = moment
                        .duration(
                            moment(endDate, "DD/MM/YYYY").diff(
                                moment(futureBirthDay, "DD/MM/YYYY")
                            )
                        )
                        .asDays();

                    var expiryDate;
                    if (daysDiff <= 0) {
                        expiryDate = moment(futureBirthDay, "DD/MM/YYYY").format(
                            "DD/MM/YYYY"
                        );
                    } else {
                        expiryDate = moment(
                            birthDay + "/" + birthMonth + "/" + startYear,
                            "DD/MM/YYYY"
                        )
                            .add(11, "years")
                            .format("DD/MM/YYYY");
                    }

                    while (
                        (moment(expiryDate, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY")) <= 0) &&
                        ((tipoDocumento === propMap["DOC_TYPE_CAI"]) || (tipoDocumento === propMap["DOC_TYPE_PAT"]))) {
                        expiryDate = moment(
                            expiryDate,
                            "DD/MM/YYYY"
                        )
                            .add(10, "years")
                            .format("DD/MM/YYYY");
                    }

                    if (moment.duration(moment(self.userDaCensire.documento.dataScadenza, "DD/MM/YYYY").diff(moment(expiryDate, "DD/MM/YYYY"))).asDays() > 0) {
                        $scope.pfForm.dataScadenza.$valid = false;
                    }
                    if (moment.duration(moment(self.userDaCensire.documento.dataScadenza, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY"))).asDays() < 2) {
                        $scope.pfForm.dataScadenza.$valid = false;
                        $scope.pfForm.dataScadenza.$setValidity("dataScadenza", false);
                    } else {
                        $scope.pfForm && $scope.pfForm.dataScadenza && $scope.pfForm.dataScadenza.$setValidity("dataScadenza", true);
                    }
                    return expiryDate;
                } else {
                    if (
                        moment
                            .duration(
                                moment(
                                    self.userDaCensire.documento.dataScadenza,
                                    "DD/MM/YYYY"
                                ).diff(moment(endDate, "DD/MM/YYYY"))
                            )
                            .asDays() > 0
                    ) {
                        $scope.pfForm.dataScadenza.$valid = false;
                    }
                    return endDate;
                }
            } else {
                return moment(self.today, "DD/MM/YYYY")
                    .add(10, "years")
                    .format("DD/MM/YYYY");
            }

        };

        self.validateForm = function () {
            self.allDocumentUploaded = checkFilesUpload();
            if (self.userDaCensire.datiNascita.provincia != "EE") {
                return $scope.pfForm.$valid &&
                    self.userDaCensire.residenza.cap &&
                    self.userDaCensire.residenza.luogoEsteso.nome &&
                    self.userDaCensire.documentiCaricati &&
                    self.allDocumentUploaded &&
                    !!self.userDaCensire.documento.tipo &&
                    self.testDati.value
            } else {
                return $scope.pfForm.$valid &&
                    self.userDaCensire.residenza.cap &&
                    self.userDaCensire.residenza.luogoEsteso.nome &&
                    self.userDaCensire.documentiCaricati &&
                    self.allDocumentUploaded &&
                    !!self.userDaCensire.documento.tipo &&
                    self.testDati.value &&
                    self.userDaCensire.email &&
                    self.userDaCensire.telefono
                //&& self.userDaCensire.numIscrizioneAlbo
            }
        };

        var checkFilesUpload = function () {
            var test = false
            if (self.userDaCensire.numDocumenti == 2) {

                test = !!self.userDaCensire.documento.imgDocumentoCfBack &&
                    !!self.userDaCensire.documento.imgDocumentoCfFront &&
                    !!self.userDaCensire.documento.imgDocumentoBack &&
                    !!self.userDaCensire.documento.imgDocumentoFront;

            } else if (self.userDaCensire.numDocumenti == 4) {

                test = !!self.userDaCensire.documento.imgDocumentoCfBack &&
                    !!self.userDaCensire.documento.imgDocumentoCfFront &&
                    !!self.userDaCensire.documento.imgDocumentoBack &&
                    !!self.userDaCensire.documento.imgDocumentoFront &&
                    !!self.userDaCensire.documento.idImgDocumentoBackOther &&
                    !!self.userDaCensire.documento.idImgDocumentoFrontOther &&
                    !!self.userDaCensire.documento.idImgSubjectPhoto;

            }

            return test;

        }

        self.getTodaysDate = function () {
            return moment().format("DD/MM/YYYY");
        };

        self.verifyDate = function () {
            self.testDati.value = true;
            var codCat;
            if (self.userDaCensire && self.userDaCensire.datiNascita &&
                self.userDaCensire.datiNascita.luogoEsteso &&
                self.userDaCensire.datiNascita.luogoEsteso.nome) {
                var tempCodCat = self.mapComuni
                    .filter(function (element) {
                        return element.nome.toUpperCase() == self.userDaCensire.datiNascita.luogoEsteso.nome.toUpperCase()
                    })[0].codiceCatastale;
                codCat = self.userDaCensire.datiNascita.luogoEsteso.codiceCatastale ? self.userDaCensire.datiNascita.luogoEsteso.codiceCatastale : tempCodCat;
            } else if (self.userDaCensire && self.userDaCensire.datiNascita && self.userDaCensire.datiNascita.stato.name) {
                codCat = self.userDaCensire.datiNascita.stato.value;
            }
            if (!codCat) {
                self.testDati.value = false;
                return;
            }

            self.testDati = validationService.checkCfWithFieds(
                self.userDaCensire.cf,
                self.userDaCensire.nome,
                self.userDaCensire.cognome,
                self.userDaCensire.datiNascita.data,
                self.userDaCensire.sesso,
                codCat
            );

            if (!self.testDati.value) {
                if (typeof $scope.pfForm.userCf != "undefined") {
                    $scope.pfForm.userCf.$setValidity("userCf", false);
                }
            } else {
                if (typeof $scope.pfForm.userCf != "undefined") {
                    $scope.pfForm.userCf.$setValidity("userCf", true);
                }
            }

        };

        self.upgradeListaComuni = function (value) {
            if (self.userDaCensire.documento.provincia) {
                self.creaComuniRilascio(self.userDaCensire.documento.provincia);
            }
            self.userDaCensire.documento.luogoEsteso = {
                nome: value
            }
        }

        var validateDelModal = function () {
            if (self.validateForm()) {
                self.userDaCensire.isOk = true;
                self.validateDocumentDel({
                    validity: true
                });
            } else {
                self.validateDocumentDel({
                    validity: false
                });
            }
        }

        var dealerUser = function () {
            if ($portalService.isAru()) {
                $userService.getDealerUser()
                    .then(function (dealer) {
                        if (dealer) {
                            self.dealerUser = dealer;
                        }
                    });
            }
        }
    }
});